module.exports = __webpack_public_path__ + "img/nu.fbb04345.png";